import {ApiClient} from '../api-client/api-client';

export class CrmSyncEndpoint {
  constructor(private client: ApiClient) {}

  /**
   * Trigger an immediate sync of a CRM integration (202 — runs in
   * background; refetch the integration's data to observe progress).
   */
  async triggerSync(integrationId: string): Promise<void> {
    await this.client.post<void>(`/api/v1/crm-sync/trigger/${integrationId}`, {});
  }
}
